<div class="confirm-modal_header">
  <div class="confirm-modal_title">
    @if (titleTranslate) {
      {{title | l10n:translationParams}}
    } @else {
      {{title}}
    }
  </div>
  <svg class="confirm-modal_close-icon" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
<div class="confirm-modal_body">
  @if (messageTranslate) {
    {{message | l10n:translationParams}}
  } @else {
    {{message}}
  }
</div>

<div class="confirm-modal_footer">
  <button type="submit" class="confirm-modal_button -cancel" (click)="close()">
    {{cancelButtonText | l10n}}
  </button>
  <button type="submit" class="confirm-modal_button -confirm" (click)="confirm()">
    {{confirmButtonText | l10n}}
  </button>
</div>
